import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DriverService } from '../shared/services/driver.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  inputType: string = "password";
  passwordCheckbox: string;
  confirmPassword: string;
  password: string;
  OldPassword: string;
  @Input() public DriverId;
  viewModel: any;
  constructor(public activeModal: NgbActiveModal, private _driverSvc: DriverService, private _toasterSvc : ToastrService) { }

  ngOnInit() {
    this._driverSvc.getChangePassword(this.DriverId).subscribe(response => {
      if (response)
        this.viewModel = response;
        this.viewModel.ID = this.DriverId;
    });
  }

  saveChangePassword() {
    this.viewModel.OldPassword = this.OldPassword;
    this.viewModel.Password = this.password;
    this._driverSvc.changePassword(this.viewModel).subscribe(response => {
      if(response){
      if(response?.error?.ResultMessages?.length > 0){
        response.error.ResultMessages.forEach(msg => {
          this._toasterSvc.error(msg.Message);
        });
      }
      else{ 
        this._toasterSvc.success("Password changed successfully", null, {
          positionClass:'toast-bottom-right'
        });
        this.activeModal.close();
      }
      }
    });
  }

  hideShowPassword() {
    this.inputType = this.inputType === "password" ? "text" : "password";
  }

  confirm() {

  }
}
